<template>
  <div
    class="signin d-flex flex-column justify-content-center align-items-center h-100 p-4"
  >
    <div class="logo-container d-flex flex-row justify-content-center">
      <HeaderLogo class="mx-auto" />
    </div>
    <div class="login-form p-4 p-sm-5 w-100 text-black">
      <div class="d-flex flex-column justify-content-between text-center">
        <div class="d-flex justify-content-center text-center">
          <img
            class="secondary-logo pb-3"
            :src="this.config ? this.config.organizationLogo : ''"
            alt=""
          />
        </div>
        <div class="d-flex flex-column mb-4">
          <h3>
            {{
              $t("login.welcome", {
                organizationName: this.config
                  ? this.config.organizationName
                  : ""
              })
            }}
          </h3>
        </div>
      </div>

      <div class="d-flex flex-row justify-content-center">
        <button
          @click="goNewClient"
          style="width: 200px;"
          class="btn btn-primary mr-4 text-uppercase"
        >
          {{ $t("login.newPatient") }}
        </button>

        <button
          @click="goSignIn"
          style="height: 60px;"
          class="btn btn-primary text-uppercase"
        >
          {{ $t("login.existingClient") }}
        </button>
      </div>

      <select-language class="lang-select" />
    </div>
  </div>
</template>

<script>
import { i18n } from "../../config/languages/i18n";
import SelectLanguage from "../../views/SelectLanguage.vue";
import HeaderLogo from "../../views/HeaderLogo.vue";
import { mapState } from "vuex";

export default {
  name: "PatientTypeIndex",
  components: { HeaderLogo, SelectLanguage },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState({
      config: state => state.session.systemSettings
    })
  },
  methods: {
    goSignIn() {
      this.$router.push("/signin");
    },
    newLanguage() {
      this.$i18n.locale = "es";
      i18n.locale = "es";
    },
    goNewClient() {
      this.$router.push("/redirect-care-clinics");
    }
  }
};
</script>

<style lang="scss" scoped>
.secondary-logo {
  width: 150px;
  height: 100px;
}
.signin {
  position: relative;
  background: linear-gradient(
    to bottom,
    #13609b,
    #208de2 47.5%,
    #f5f6f9 47.5%,
    #f5f6f9
  );

  .logo-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% - 235px));
  }
}

.login-form {
  max-width: 575px;

  .lang-select {
    float: left;
    font-size: 0.7em;
    max-width: 100px;
    margin-top: 2em;
  }

  input {
    font-size: 0.8em;
  }
}
</style>
